(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "8eefff78a4312710080dcfb1e0d6a179ea3e4d5e"
};